export enum PreferenceType {
  topics = 'topics',
  comms_ReplyOnMyPost = 'Comms_ReplyOnMyPost',
  comms_ReactionOnMyPost = 'Comms_ReactionOnMyPost',
  comms_SomeoneAcceptsMyRequest = 'Comms_SomeoneAcceptsMyRequest',
  comms_SomeoneRejectsMyRequest = 'Comms_SomeoneRejectsMyRequest',
  comms_IReceiveACompanionRequest = 'Comms_IReceiveACompanionRequest',
  comms_SomeoneCommentsOnMyStory = 'Comms_SomeoneCommentsOnMyStory',
  comms_SomeoneReactsOnMyStory = 'Comms_SomeoneReactsOnMyStory',
  comms_SomeonePublishesAStory = 'Comms_SomeonePublishesAStory',
  comms_NewStoriesFromTheAuthorsIFollow = 'Comms_NewStoriesFromTheAuthorsIFollow',
  comms_IReceivecarepointsReward = 'Comms_IReceivecarepointsReward',
  comms_UpdateMyHealthJourney = 'Comms_UpdateMyHealthJourney',
  comms_UpdateMyMoodTracker = 'Comms_UpdateMyMoodTracker',
  comms_MyPollHasNewResponses = 'Comms_MyPollHasNewResponses',
  comms_MyPollHasBeenClosed = 'Comms_MyPollHasBeenClosed',
  comms_NewPollInRoomsIFollow = 'Comms_NewPollInRoomsIFollow',
  comms_SomeoneStartsAConversation = 'Comms_SomeoneStartsAConversation',
}
